module.exports = __webpack_public_path__ + "assets/5ff61f11d12b29c6690cd1226e9854fb.mp3";